module.exports = __webpack_public_path__ + "img/reader_success.b84a0c0.svg";